import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Avatar, Popover } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { HeaderProps } from "utils/types";
import { ConditionalRenderer } from "components/conditonal-renderer";
import { isNull } from "./helpers";
import { useCurrentUserContext } from "providers";
import Logout from "components/logout";
import {
  getCurrentEnviornment,
  localStorageLiveUserId,
  localStorageSandboxUserId,
} from "utils/constants";
import styles from "./styles.module.scss";

interface RenderAvatarProps {
  className?: {
    custom?: string;
    generic?: string;
  };
  user: User;
}

interface User {
  picture?: string;
  picturePath?: string | null;
}

export function Header({ showHeader }: HeaderProps) {
  const darkMode = localStorage.getItem("darkMode");
  const myAuth = Cookies.get(`${getCurrentEnviornment()}_sessionToken`);
  const myMode = darkMode === "true";
  const icon = myMode ? "logoTwo.png" : "logo.png";
  const location = useLocation();
  const navigate = useNavigate();
  const { user, saveUserData } = useCurrentUserContext();
  const [visible, setVisible] = useState(false);

  // const [getData] = UseLazyApiCallV2({
  //   method: "POST",
  //   url: "/logout_user",
  // }) as any;

  // const logoutHandler = async () => {
  //   const response = await getData({
  //     params: {
  //       email: user?.email,
  //     },
  //   });

  //   if (response) {
  //     Cookies.remove("sessionToken");
  //     localStorage.removeItem("userId");
  //     localStorage.removeItem("userEmail");
  //     saveUserData(null);

  //     navigate("/");
  //   }
  // };

  // const handleBeforeUnload = (event: any) => {
  //   event.preventDefault();
  //   logoutHandler();
  // };

  // useEffect(() => {
  //   if (!user && location.pathname !== "/set-password") {
  //     return;
  //   }
  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  // }, [user]);

  // useEffect(() => {
  //   if (!myAuth && location.pathname !== "/set-password") {
  //     logoutHandler();
  //   }
  // }, [myAuth]);

  function handleClickLogo() {
    if (localStorageLiveUserId() || localStorageSandboxUserId()) {
      return;
    }
    navigate("/");
  }

  const content = (
    <div className={styles["pop-content"]}>
      <div className={styles["pop-logout"]}>
        <Logout setVisible={setVisible} />
      </div>
    </div>
  );

  return (
    <div className={styles["header-container"]}>
      <div className={styles.headerItems}>
        <div className={styles.backBtn}></div>
        <img
          src={`/assets/logos/${icon}`}
          alt="logo"
          className={styles.logo}
          onClick={handleClickLogo}
        />

        <ConditionalRenderer condition={showHeader}>
          <Popover
            className={styles.customPopover}
            content={content}
            title={false}
            placement="bottomRight"
            trigger="click"
            visible={visible}
            onOpenChange={(event: any) => setVisible(event)}
          >
            <div className={styles.popoverContent}>
              <div className={styles.nameContainer}>
                <h2 style={{ margin: "0" }}>{user?.username}</h2>
              </div>
              <div style={{ cursor: "pointer" }}>
                <RenderAvatar
                  className={{
                    custom: styles.customAvatar,
                    generic: styles.genericAvatar,
                  }}
                  user={user}
                />
              </div>
            </div>
          </Popover>
        </ConditionalRenderer>
      </div>
      <img
        src="/assets/images/footerLine.png"
        alt="footer-line"
        className={styles.footerLine}
      />
    </div>
  );
}

function RenderAvatar({ className, user }: RenderAvatarProps): JSX.Element {
  if (!isNull(user?.picture)) {
    return (
      <Avatar className={className?.custom} src={user?.picture} alt="avatar" />
    );
  }
  if (!isNull(user?.picturePath)) {
    return (
      <Avatar
        className={className?.custom}
        src={user?.picturePath}
        alt="avatar"
      />
    );
  }
  return <Avatar className={className?.generic} icon={<UserOutlined />} />;
}
